import getErrors from '../../../../shared/lib/geterrors';
import InternokironService from '../../../../shared/services/api/internokiron';

export const onInternokironSubmit = (
  values,
  { setSubmitting, setErrors, setValues },
  { anagraficaId, update, notifications }
) => {
  const payload = {
    ...values,
    anagrafica: anagraficaId,
    profili: values.profili.map((obj) => obj.value),
  };

  if (!values.id || values.id.length === 0) {
    InternokironService.create(payload)
    .then((data) => {
      setSubmitting(false);

      // Update form values if needed
      setValues({ ...values, id: data.id });

      // Success notification
      notifications.addNotification({
        message: 'Dati interno Kiron salvati',
        level: 'success',
      });

      // Update parent list
      update();
    })
    .catch((errors) => {
      const errorsObj = getErrors(errors);
      setSubmitting(false);
      setErrors(errorsObj);

      // Error notification
      notifications.addNotification({
        message: 'Si è verificato un problema con il salvataggio dell\'interno kiron, ricontrolla i campi inseriti',
        level: 'error',
      });
    });
  } else {
    InternokironService.put(payload)
      .then(() => {
        setSubmitting(false);
        notifications.addNotification({
          message: 'Dati interno kiron aggiornati',
          level: 'success',
        });
      })
      .catch((errors) => {
        const errorsObj = getErrors(errors);
        setSubmitting(false);
        setErrors(errorsObj);

        // Error notification
        notifications.addNotification({
          message: 'Si è verificato un problema con il salvataggio del responsabile area, ricontrolla i campi inseriti',
          level: 'error',
        });
      });
  }
};

export default onInternokironSubmit;



// WEBPACK FOOTER //
// ./app/components/Forms/Anagrafica/InternoKiron/submit.js